import React from 'react'
import { Link } from 'react-router-dom'

const handledCloseSession = async (param) => {
    localStorage.clear();
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

    // Escoge el basename según entorno
    const BASENAME = isLocalhost
        ? process.env.REACT_APP_BASENAME_LOCAL
        : process.env.REACT_APP_BASENAME_PROD2

    window.location.href = BASENAME
}

const NavBar = () => {

    return (
        <>
            <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <a href="!#" className="nav-link" data-widget="pushmenu" role="button"><i className="fas fa-bars"></i></a>
                    </li>
                </ul>
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item">
                        <Link to={global.ROUTE_ESTABLISHMENTS} className="nav-link" role="button"><i className="fas fa-building"></i></Link>
                    </li>
                    <li className="nav-item dropdown">
                        <a href="!#" className="nav-link" data-toggle="dropdown">
                            <i className="nav-icon fas fa-user" style={{ color: 'lightseagreen' }}> ghuayamabe</i>
                        </a>
                        <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                            <div className="dropdown-divider"></div>
                            <Link to={global.PERFIL_USER} className="dropdown-item">
                                Perfil
                                <span className="float-right text-muted text-sm"><i className="nav-icon fas fa-arrow-right" style={{ color: 'lightseagreen' }}></i></span>
                            </Link>
                            <div className="dropdown-divider"></div>
                            <button className="dropdown-item dropdown-footer" onClick={handledCloseSession}>
                                <i className="nav-icon fas fa-lock" style={{ color: 'lightseagreen' }}></i> Cerrar sesión
                            </button>
                        </div>
                    </li>
                </ul>
            </nav>
        </>
    )
}

export default NavBar
